<template>
    <div>
        <quill-editor 
            ref="text" 
            v-model="content" 
            class="myQuillEditor" 
            :options="editorOption" 
            style="width:800px;"/>
    </div>
</template>
<script>
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    export default {
        components: {
            quillEditor
        },
        props: {},
        data() {
            return {
                content: '',
                editorOption: {
                    modules: {   
                        toolbar: [ 
                            ['bold', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
                            [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
                            [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
                            // [{ 'direction': 'rtl' }],             // 文本方向
                            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
                            [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
                            [{ 'font': [] }],     //字体
                            [{ 'align': [] }],    //对齐方式
                        ]
                    },
                    placeholder: '请输入内容'
        　　　　 }
            }
        },
        mounted() {
            if (this.typeImg && this.attachments && this.attachments.length > 0) {
                this.getUrl(0)
            }
        },
        methods: {
            submit () {
                console.log(this.$refs.text.value)
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/index.vue